module.exports = __webpack_public_path__ + "img/news-2.75ae017a.jpg";